<template>
  <div class="plugin_popup_wrapper">
    <button class="btn plugin_popup_button" @click="triggerPopup()" v-show="buttonText">{{buttonText}}</button>

    <div :class="[`plugin_popup plugin_${pluginId}`,{ 'is_active': isActive }]" v-show="isActive" ref="plugin">
      <div class="plugin_popup_header">
        <h4 class="plugin_popup_name"></h4>
        <div class="plugin_popup_close_btn" @click="close()">&times;</div>
      </div>
      <div class="plugin_popup_content_wrapper">
        <div class="plugin_popup_content" v-html="content"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PluginPopup',

  props: {
    pluginId: { type: Number },
    pluginType: { type: String },
    pluginButton: { type: String }
  },

  data() {
    return {
      content: '',
      isActive: false
    }
  },

  watch:{
    content(val) {
      var self = this
      if(val){
        this.$nextTick(()=>{
          self.setupFormSubmit()
        })
      }
    }
  },

  created() {
    this.loadPopup()
  },

  mounted() {
    this.setScrollableFade()
  },

  computed: {
    buttonText() {
      return this.pluginButton || 'Engage';
    }
  },

  methods: {
    triggerPopup() {
      if (this.pluginType === 'Library') {
        var libraryUrl = `/libraries/${this.pluginId}`
        window.open(libraryUrl, '_blank').focus();
      } else {
        this.isActive = !this.isActive
      }
    },
    close() {
      this.isActive = false
    },
    setScrollableFade() {
      // Hide popup if user scrolls down the page
      $(window).scroll(function() {
          var windowTop = $(window).scrollTop() - 0;
          $('.plugin_popup.is_active').each(function(i, obj) {
              var popupTop = $(this).offset().top;

              if (windowTop > popupTop) {
                  $(this).css('opacity','0');
              } else {
                  $(this).css('opacity','1');
              }
          });
      });
    },
    refreshDropdowns() {
      setTimeout(function(){
          $('.selectpicker').selectpicker('refresh');
          $('.dropdown-menu.inner').addClass('show')
      }.bind(this), 0);
    },
    getPluginRoute() {
      switch (this.pluginType) {
        case 'EventForm':
          return 'forms';
        case 'QuestionPlugin':
          return 'questions';
        default:
          return null;
      }
    },
    loadPopup() {
      var self = this
      var pluginRoute = this.getPluginRoute()
      if (this.pluginId && pluginRoute) {
        var params = {
          'embedded': true
        }
       
        $.get(`/${pluginRoute}/${this.pluginId}`, params, function(res) {
            self.initPopup(res.data)
        });
      }
    },
    setupFormSubmit() {
      var self = this
      var $form = $(this.$refs.plugin).find('form')

      $form.submit(function(event) {
        event.preventDefault()
        var url = this.getAttribute('action')
        var data = $(this).serialize()

        // Set plugin id and type to pass
        data+=`&plugin_id=${self.pluginId}&plugin_type=${self.pluginType}`

        $.post(url, data, function (res) {
          self.content = '<span class="submitted_msg">Thanks! Your answers have been successfully submitted!</span>'
          $
        })
      })
    },
    initPopup(data) {
      this.content = data.view
      this.refreshDropdowns()
    }
  }
}
</script>
<style>
  .plugin_popup_wrapper {
    position: relative;
  }
  .plugin_popup {
    position: absolute;
    bottom: 0;
    max-width: 300px;
    background-color: white;
    padding: 15px;
    border-radius: 15px;
    pointer-events: all;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.1);
    z-index: 10000;
    transition: .3s;
    width: 300px;
    height: 400px;
    overflow: auto;
    opacity: 1;
  }

  .plugin_popup_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
  }

  .plugin_popup_close_btn {
    font-size: 20px;
    font-weight: bold;
    cursor: pointer;
    margin-bottom: 8px;
  }
  .plugin_popup input#secondary_submit_btn {
    display: none;
  }
  .plugin_popup .row {
    margin: 0;
  }
  .plugin_popup .container,
  .plugin_popup .form__section-description {
    padding: 0;
  }
  .plugin_popup #content,
  .plugin_popup .tab-content {
    padding: 0;
  }
  .plugin_popup .tab-content {
    padding-bottom: 15px;
  }
  .plugin_popup .form-content,
  .plugin_popup .tab-content {
    background-color: unset;
  }
</style>